module.exports = __webpack_public_path__ + "static/img/dev.941b2e3a.svg";